/* eslint-disable max-len */
/* eslint-disable vue/max-len */

import { create } from '@bufbuild/protobuf';

import * as pbm from '@/grpc-gen/message_pb';

export enum MessageType {
  EMAIL = 'email',
  SMS = 'sms',
}

export default class Message {
  messageType: MessageType = MessageType.EMAIL;

  reservationId?: number;

  feedbackId?: number;

  subject?: string;

  body?: string;

  sendBcc: boolean = false;

  constructor(o?: { messageType?: MessageType, reservationId?: number, feedbackId?: number, subject?: string, body?: string, sendBcc?: boolean}) {
    if (o?.messageType) this.messageType = o.messageType;
    if (o?.reservationId) this.reservationId = o.reservationId;
    if (o?.feedbackId) this.feedbackId = o.feedbackId;
    if (o?.subject) this.subject = o.subject;
    if (o?.body) this.body = o.body;
    if (o?.sendBcc) this.sendBcc = o.sendBcc;
  }

  toGrpcModel(): pbm.Message {
    return create(pbm.MessageSchema, {
      messageType: this.messageType === MessageType.SMS ? pbm.Message_MessageType.SMS : pbm.Message_MessageType.SENDGRID,
      reservationId: BigInt(this.reservationId ?? 0),
      feedbackId: BigInt(this.feedbackId ?? 0),
      subject: this.subject ?? '',
      body: this.body ?? '',
      sendBcc: this.sendBcc ?? false,
    });
  }
}
